export default "__VITE_ASSET__CSVnVSqm__"